import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import campaignIds from '../../../constants/campaignIds';

// mandatory - use dynamic imports - so each component is only loaded when needed
// loadable components mandatory requirement - functional component and export default
const CampaignRoutes_default = lazy(
  async () => await import('./CampaignRoutes_default')
);
const CampaignRoutes_MG = lazy(async () => await import('./CampaignRoutes_MG'));
const CampaignRoutes_HG = lazy(async () => await import('./CampaignRoutes_HG'));
const CampaignRoutes_VL = lazy(async () => await import('./CampaignRoutes_VL'));
const CampaignRoutes_ES = lazy(async () => await import('./CampaignRoutes_ES'));
const CampaignRoutes_AK = lazy(async () => await import('./CampaignRoutes_AK'));
const CampaignRoutes_MB = lazy(async () => await import('./CampaignRoutes_MB'));
const CampaignRoutes_HS = lazy(async () => await import('./CampaignRoutes_HS'));

/**
 * The CampaignRoutes component conditionally returns the campaign specific routes component or the default routes component.
 * If a campaignId matches a specific component, this component will be loaded.
 * In case the campaignId does not match any component the default routes are used.
 * TODO - in imports and in switch-case-statement - remeber to add the missing active campaign routes components or remove old inactive
 * @returns campaign specific routes component or default routes component
 */
export const CampaignRoutes = () => {
  const campaignId = process.env.ERGO_CAMPAIGN_ID;
  let currentCampaignRoutes;
  switch (campaignId) {
    case campaignIds.MG:
      currentCampaignRoutes = <CampaignRoutes_MG />;
      break;
    case campaignIds.HG:
      currentCampaignRoutes = <CampaignRoutes_HG />;
      break;
    case campaignIds.VL:
      currentCampaignRoutes = <CampaignRoutes_VL />;
      break;
    case campaignIds.ES:
      currentCampaignRoutes = <CampaignRoutes_ES />;
      break;
    case campaignIds.AK:
      currentCampaignRoutes = <CampaignRoutes_AK />;
      break;
    case campaignIds.MB:
      currentCampaignRoutes = <CampaignRoutes_MB />;
      break;
    case campaignIds.HS:
      currentCampaignRoutes = <CampaignRoutes_HS />;
      break;
    default:
      currentCampaignRoutes = <CampaignRoutes_default />;
      break;
  }
  // console.log('currentCampaignRoutes ? ', currentCampaignRoutes);

  return (
    <Routes>
      <Route path='*' element={currentCampaignRoutes} />
    </Routes>
  );
};
